import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { EventCard, EventType } from "./event-card/EventCard";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { Link } from "react-router";
import { Pages } from "../../utils";
import greenImage from "../../assets/events/green-event.jpg";
import limeImage from "../../assets/events/lime-event.jpg";
import { HeroImage } from "../../components/static-page-components/hero-image";
import desktopImage from "../../assets/events/hero-d.jpg";
import mobileImage from "../../assets/events/hero-m.jpg";
import "./styles.scss";

type Event = {
  id: string;
  link: string;
  image: string;
  title: string;
  date: string;
  location: string;
  tag: string;
  type: EventType;
};

const events: Event[] = [
  // {
  //   id: "1",
  //   image: greenImage,
  //   tag: "Networking",
  //   date: "April 26, 2025",
  //   title: "Home Design Guild Launch Party",
  //   location: "High Point, NC",
  //   link: "https://lp.homedesignguild.com/launch",
  //   type: EventType.LIVE,
  // },
  // {
  //   id: "2",
  //   image: limeImage,
  //   tag: "Education",
  //   date: "April 26 - 29, 2025",
  //   title: "Navigating Client Realtionships",
  //   location: "High Point, NC",
  //   link: "https://lp.homedesignguild.com/colorworks",
  //   type: EventType.LIVE,
  // },
  {
    id: "3",
    image: limeImage,
    tag: "Networking",
    date: "August 20th, 2025",
    title: "An Afternoon of Inspired Content & Connecting",
    location: "Atlanta Georgia",
    link: "https://lp.homedesignguild.com/atlanta-designers-event",
    type: EventType.LIVE,
  },
];

export const EventsLandingPage = () => {
  return (
    <Box className="page events-landing-page">
      <HeroImage mobileImage={mobileImage} image={desktopImage}>
        <Box
          className="hero-content"
          sx={{
            minHeight: "262px",
            mx: "auto",
            p: {
              xs: "16px",
              md: "28px",
            },
            borderRadius: "16px",
            maxWidth: "544px",
          }}
          justifyContent="center"
          display="flex"
          flexDirection={"column"}
        >
          <Typography
            variant={"display1" as any}
            component="h1"
            sx={{ color: "#fff", mb: "16px" }}
          >
            EVENTS & EXPERIENCES
          </Typography>
          <Typography variant="body1" className="text-white">
            Get to know your local design community while picking up new tips,
            tricks, and ideas to grow your business.
          </Typography>
        </Box>
      </HeroImage>

      <LandingPageSection>
        <Grid2 container spacing={2} columns={12}>
          {events.map((event) => (
            <Grid2 key={event.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <EventCard
                eventTitle={event.title}
                eventDate={event.date}
                eventImage={event.image}
                eventLink={event.link}
                eventLocation={event.location}
                eventTag={event.tag}
                eventType={event.type}
              />
            </Grid2>
          ))}
        </Grid2>
      </LandingPageSection>

      <LandingPageSection className="text-center pink-section">
        <Stack spacing={3}>
          <Typography
            variant="h4"
            className="font-body font-size-5"
            sx={{ color: "#fff" }}
          >
            Ready For Your Next Big, Meaningful Relationship?
          </Typography>
          <Typography
            variant="h6"
            fontWeight={400}
            className="font-body text-size-3"
            sx={{ color: "#fff" }}
          >
            Explore your options and find a match that fits.
          </Typography>
          <div>
            <Button
              color={"white" as any}
              variant="contained"
              className="font-size-4 font-body"
              sx={{ p: 2 }}
              component={Link}
              to={Pages.SIGNUP}
            >
              Join Our Guild
            </Button>
          </div>
        </Stack>
      </LandingPageSection>
    </Box>
  );
};
